import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import { Grid } from '@material-ui/core';
import { withRouter } from 'react-router';
import DbTasks from '../../db/DbTasks';
import BackdropSpinner from '../Reusable/BackdropSpinner';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import { Remove } from '../../bundles/IconsBundle';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '90%',
        //maxWidth: '36ch',
        backgroundColor: theme.palette.background.paper,

        flexGrow: 1,
        margin: theme.spacing(0),
    },
    inline: {
        display: 'inline',
    },
    availableStatus: {
        width: 10,
        height: 10,
        backgroundColor: 'green',
        borderRadius: '40%'
    },
    rootSearch: {
        margin: theme.spacing(1),
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        border: '1px solid #cce0ff'
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 10,
        color: '#1976d2',
    },
}));


function UsersList(props) {
    const classes = useStyles();
    //const [usersList, setUsersList] = useState([]);
    const [localState, setLocalState] = useState({
        usersList: [],
        showLoading: true,
        reload: false,
        showClear: false
    });
    // const [showLoading, setLoading] = useState(true);
    // const [reload, setReload] = useState(false);
    // const [showClear, setClear] = useState(false);

    useEffect(() => {
        let searchParam = document.getElementById("userSearch").value || "";
        new DbTasks().getDataFromDb(`api/Chat/GetChatUsers/?userSearch=${searchParam}`, {}, { method: "GET" })
            .then(res => {
                //console.log("Chat users : ", res);
                setLocalState({...localState, usersList: res, showLoading: false });
                // setUsersList(res);
                // setLoading(false);
            }).catch(() => {
                setLocalState({ showLoading: false });
                //setLoading(false);
                alert("Error happened while getting chat users.")
            });
        return () => {
            console.log("Running cleanup function !");
        }
    }, [localState.reload]);

    const openChatHistory = (id, beraterName) => {
        //setBeraterChatName(beraterName);
        props.history.push(`/chat/${id}`);
    }

    const renderUserSingle = (data) => {
        return (<React.Fragment key={data.id}>
            <ListItem alignItems="center" onClick={() => openChatHistory(data.id, data.beraterName)}>
                <ListItemAvatar>
                    <Avatar alt={data.initials || ""} src="" />
                </ListItemAvatar>
                <ListItemText
                    primary={data.beraterName || ""}
                />

            </ListItem>
            <Divider variant="inset" component="li" />
        </React.Fragment>
        )

    }

    return (
        <Grid container spacing={0} alignContent='center' justify='center'>
            <Grid item lg={3} md={4} sm={6} xs={12} >
                <Paper className={classes.rootSearch}>
                    <InputBase
                        id="userSearch"
                        className={classes.input}
                        placeholder="Nutzer suchen"
                        onChange={(e) => {
                            if (e.currentTarget.value !== "") {
                                setLocalState({...localState, showClear: true });
                            }else{
                                setLocalState({...localState, showClear: false });
                            }
                        }}
                        onKeyPress={(e)  => {
                            if(e.key === "Enter"){
                                setLocalState({...localState, reload: !localState.reload });
                            }
                        }}
                    //inputProps={{ 'aria-label': 'search google maps' }}
                    />
                    {localState.showClear === true ?
                        <IconButton
                            //type="submit"
                            onClick={() => {
                                setLocalState({...localState, reload: !localState.reload, showClear: false });
                                document.getElementById("userSearch").value = "";
                            }}
                            className={classes.iconButton}
                            aria-label="search">
                            <Remove />
                        </IconButton> :
                        <IconButton
                            //type="submit"
                            onClick={() => setLocalState({...localState, reload: !localState.reload })}
                            className={classes.iconButton}
                            aria-label="search">
                            <SearchIcon />
                        </IconButton>

                    }

                </Paper>
                {/* <TextFields
                        //onChange={(e) => setSearch(e.currentTarget.value)}                        
                        //value={searchValue}
                        id="userSearch"
                        type="text"
                        label="User search"
                        variant="outlined"
                        fullWidth={true}
                        //error={true}
                        //helperText={"Wrong pass or username"}
                        onKeyPress={(e)  => {
                            if(e.key === "Enter"){
                                setReload(!reload);
                            }
                        }}
                        class={classes.elementSpacing}
                    // style={style.textField} 
                    /> */}
                <List className={classes.root} key={-1}>
                    {localState.usersList && localState.usersList.map((item) => renderUserSingle(item))}

                </List>
            </Grid>
            <BackdropSpinner showLoading={localState.showLoading} />
        </Grid>
    );
}

export default withRouter(UsersList);